module.exports = __webpack_public_path__ + "static/widget-img-12-35d7b8fe7e22f4274dcf3eaf52763c00.png";